import React from 'react';
import { useLocation } from 'react-router-dom';
import { Page } from '../Common/Components/Page';
import { SettingsLayout } from './Components/SettingsLayout';
import SettingsSectionProvider from './Providers/SettingsSectionProvider';

export const Settings = (): React.JSX.Element => {
  // Admin sections are list views — they need the page-header search bar
  // and pagination. Personal sections (Profile/Security/etc.) don't.
  // Integrations is an admin section but brings its own inline search, so it
  // opts out of the header bar as well.
  // Deciding here means Page's `isSearchable` effect lines up with the
  // active route on first paint, avoiding a child-vs-parent useEffect
  // race that hides the header on a fresh load of /me/admin/*.
  const { pathname } = useLocation();
  const isAdminSection = pathname.startsWith('/me/admin/') && !pathname.startsWith('/me/admin/integrations');

  return (
    <Page title="Settings" isSearchable={isAdminSection}>
      <SettingsSectionProvider>
        <SettingsLayout />
      </SettingsSectionProvider>
    </Page>
  );
};
